import { render, staticRenderFns } from "./LibraryItem.vue?vue&type=template&id=20a9ea28"
import script from "./LibraryItem.vue?vue&type=script&lang=js"
export * from "./LibraryItem.vue?vue&type=script&lang=js"
import style0 from "./LibraryItem.vue?vue&type=style&index=0&id=20a9ea28&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports